const configuredProfileTrackMaxSizeMb = Number(process.env.REACT_APP_PROFILE_TRACK_MAX_SIZE_MB || 10);

export const PROFILE_TRACK_MAX_SIZE_MB = Number.isFinite(configuredProfileTrackMaxSizeMb)
  && configuredProfileTrackMaxSizeMb > 0
  ? configuredProfileTrackMaxSizeMb
  : 10;

export const ACCEPTED_AUDIO_MEDIA_TYPES = [
  'audio/mpeg',
  'audio/mp3',
  'audio/wav',
  'audio/wave',
  'audio/x-wav',
  'audio/aac',
  'audio/x-aac',
  'audio/mp4',
  'audio/x-m4a',
  'audio/ogg',
  'audio/webm',
  'audio/flac',
  'audio/x-flac',
];

export const AUDIO_MEDIA_ACCEPT = ACCEPTED_AUDIO_MEDIA_TYPES.join(',');
